import { render, staticRenderFns } from "./AppCollectionsCategorySelector.vue?vue&type=template&id=0f677de0&scoped=true&"
import script from "./AppCollectionsCategorySelector.vue?vue&type=script&lang=ts&"
export * from "./AppCollectionsCategorySelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppCollectionsCategorySelector.vue?vue&type=style&index=0&id=0f677de0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f677de0",
  null
  
)

export default component.exports